<script>
import axios from 'axios';
import { formatCurrency } from "@/helpers/function";
import { getSubMenus } from '@/utils/menuAccess';

export default {
  props: {
    cust_id: {
      type: Number,
    },
    order_id: {
      type: String,
    }
  },
  data() {
    return {
      Collection: [],
      outstanding_amount: '',
      late_payment: '',
      unresolved_invoice: '',
    }
  },
  computed: {
    accessibleSubMenus() {
      const subMenus = getSubMenus("AR Module");
      // console.log("Stat.vue - Accessible SubMenus:", subMenus);
      return subMenus;
    }
  },
  methods: {
    getdashboarddata(cust_id) {
      axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt');
      axios.get(process.env.VUE_APP_AR_API_BASEURL + 'dashboard/customer/info/' + cust_id)
        .then(response => {
          if (response) {
            this.outstanding_amount = response.data.total_outstanding_amount;
            this.late_payment = response.data.total_late_payment;
            this.unresolved_invoice = response.data.total_unresolved_invoice;
          } else {
            this.messageBag = ['No record.'];
          }
        })
        .catch(error => {
          this.messageBag = [error.error];
        });
    },
    formatCurrency,
  },
  mounted() {
    this.getdashboarddata(this.cust_id);
  }
}
</script>

<template>
  <div class="row">                      
    <div class="col-xl-4">
      <div class="card card-animate">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 overflow-hidden ms-3">
              <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                TOTAL OUTSTANDING AMOUNT
              </p>
              <div class="row d-flex align-items-center mb-3">
                <div class="col-sm-12">
                  <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                    <span class="counter-value"> {{ formatCurrency(outstanding_amount) }}</span>
                  </h4>
                </div>
              </div>
              <div v-if="accessibleSubMenus.includes('instant pay')">
                <router-link style="font-size: 16px;" class="w-100 btn-lg btn btn-success" :to="'/ar/instantpay/' + order_id">Add Payment</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- end card body -->
      </div>
    </div>

    <div class="col-xl-4">
      <div class="card card-animate">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 overflow-hidden ms-3">
              <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                Unresolved Invoices
              </p>
              <div class="row d-flex align-items-center mb-3">
                <div class="col-sm-12">
                  <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                    <span class="counter-value"> {{ unresolved_invoice }}</span>
                  </h4>
                </div>
              </div>
              <div v-if="accessibleSubMenus.includes('invoices')">
                <router-link style="font-size: 16px; background-color: #FF7F41;" class="w-100 btn-lg btn btn-danger" :to="'/ar/invoices/invoice-creation/' + cust_id">Create Invoice</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- end card body -->
      </div>
    </div>

    <div class="col-xl-4">
      <div class="card card-animate">
        <div class="card-body">
          <div class="d-flex align-items-center">
            <div class="flex-grow-1 overflow-hidden ms-3">
              <p class="align-items-center text-uppercase fw-medium text-muted text-truncate mb-3" style="font-size: 16px;">
                Unresolved Credit Notes
              </p>
              <div class="row d-flex align-items-center mb-3">
                <div class="col-sm-12">
                  <h4 class="fs-4 flex-grow-1 mb-0 text-end">
                    <span class="counter-value"> {{ late_payment }}</span>
                  </h4>
                </div>
              </div>
              <div v-if="accessibleSubMenus.includes('credit notes')">
                <router-link style="font-size: 16px;" class="w-100 btn-lg btn btn-primary" :to="'/ar/credit_notes/create/' + cust_id">Create Credit Note</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- end card body -->
      </div>
    </div>

    <div class="col-xl-4"></div>
    <div class="col-xl-4"></div>
  </div>
</template>